import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool, component_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizNotice } = component_tool;
class TableList extends WizContainer {

  componentName = 'TableList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handlePosition = (nextProps, nextState, key) => {
    if (nextProps[key]['list']) {
      let list = nextProps[key]['list'];
      let _list = [];
      list && list.forEach(e => {
        _list.push({ code: e.positionId, codeName: e.positionName })
      });
      nextProps[key]['data'] = _list;
    }
    return true;
  }
  
  _handleOrg = (nextProps, nextState, key) => {
    if (nextProps[key]['brandList']) {
      let list = nextProps[key]['brandList'];
      let _list = [];
      list && list.forEach(e => {
        _list.push({ code: e.orgId, codeName: e.orgName })
      });
      nextProps[key]['data'] = _list;
    }
    return true;
  }

  _render() {
    let _templateConfig = templateConfig({
      _btnFun: (e) => { log.info('123111111111111111111111111111111111111111111') }
    })
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        getPosition: this._handlePosition,
        getOrg: this._handleOrg
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(TableList);
